import React from 'react';
import { Button } from '../ui/button';
import { Upload, Download, Users, School, Calendar, User } from 'lucide-react';

const ImportExportTab = ({ 
    stats,
    onImportAthletes,
    onImportSchools,
    onExport
}) => {
    return (
        <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Import Section */}
                <div className="bg-[#0d2847] border border-white/5 p-6">
                    <h3 className="font-heading font-bold text-lg uppercase mb-4 flex items-center gap-2">
                        <Upload className="w-5 h-5 text-primary" />
                        Import Data
                    </h3>
                    <p className="text-sm text-muted-foreground mb-6">
                        Upload CSV, Excel (.xlsx, .xls), or JSON files to bulk import athletes or schools.
                    </p>
                    <div className="space-y-4">
                        <div className="p-4 bg-[#0a1628] border border-dashed border-white/20">
                            <p className="text-xs text-muted-foreground mb-2">CSV/Excel Format for Athletes:</p>
                            <code className="text-xs text-primary">full_name,age_category,country,city,school,sports</code>
                            <p className="text-xs text-muted-foreground mt-2">Note: Use semicolons for multiple sports (e.g., "Football;Basketball")</p>
                        </div>
                        <div className="p-4 bg-[#0a1628] border border-dashed border-white/20">
                            <p className="text-xs text-muted-foreground mb-2">CSV/Excel Format for Schools:</p>
                            <code className="text-xs text-primary">school_name,country,city,sport,rank,points,wins,losses</code>
                        </div>
                        <div className="flex gap-2">
                            <Button
                                onClick={onImportAthletes}
                                variant="outline"
                                className="flex-1 border-white/10"
                            >
                                <Users className="w-4 h-4 mr-2" />
                                Import Athletes
                            </Button>
                            <Button
                                onClick={onImportSchools}
                                variant="outline"
                                className="flex-1 border-white/10"
                            >
                                <School className="w-4 h-4 mr-2" />
                                Import Schools
                            </Button>
                        </div>
                    </div>
                </div>

                {/* Export Section */}
                <div className="bg-[#0d2847] border border-white/5 p-6">
                    <h3 className="font-heading font-bold text-lg uppercase mb-4 flex items-center gap-2">
                        <Download className="w-5 h-5 text-accent" />
                        Export Data
                    </h3>
                    <p className="text-sm text-muted-foreground mb-6">
                        Download platform data as CSV files for reporting or backup.
                    </p>
                    <div className="space-y-3">
                        <Button onClick={() => onExport('athletes')} variant="outline" className="w-full border-white/10 justify-start">
                            <Users className="w-4 h-4 mr-2" />
                            Export Athletes ({stats?.total_athletes || 0})
                        </Button>
                        <Button onClick={() => onExport('tournaments')} variant="outline" className="w-full border-white/10 justify-start">
                            <Calendar className="w-4 h-4 mr-2" />
                            Export Tournaments ({stats?.total_tournaments || 0})
                        </Button>
                        <Button onClick={() => onExport('users')} variant="outline" className="w-full border-white/10 justify-start">
                            <User className="w-4 h-4 mr-2" />
                            Export Users ({stats?.total_users || 0})
                        </Button>
                        <Button onClick={() => onExport('schools')} variant="outline" className="w-full border-white/10 justify-start">
                            <School className="w-4 h-4 mr-2" />
                            Export Schools ({stats?.total_schools || 0})
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ImportExportTab;
